import { Card, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { formatDate } from '../../../utils/date';  
import { SurveyItem } from '../types/index.ts';
import { useTranslation } from "react-i18next";

export default function PendingSurveyCard({ survey }: { survey: SurveyItem }) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const handleSurvey = (idSurvey: string) => {
        navigate("/survey/" + idSurvey + "/1" ); 
    }

    return (
        <>
            <Card
                style={{
                backgroundColor: "#F5F5F5",
                border: "none",
                borderRadius: "1rem",
            }}
                className="d-flex m-0 pendent">
                <Card.Text>
                    <Row>
                        <Col xs={12} md={12}>
                            <img
                            src="calendar.svg"
                            alt="Language"
                                style={{ width: '15px', }} /> {formatDate(survey.answerDate)}
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} className="titEnquesta">
                           {survey.description}
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12}>
                            <div className="badge bg-dark-subtle text-dark-emphasis rounded-pill" >{survey.status}</div>
                        </Col>
                    </Row>
                    <Row>
                        <Button variant="success" onClick={() => handleSurvey(survey.id)}>
                            {t("surveyPendingButtonReply")}
                        </Button>
                    </Row>
                </Card.Text>
            </Card>
        </>
    );


}